import React, { useCallback, useEffect } from 'react';

import { useDispatch } from 'react-redux';

import {
    bapActiveInteractionDuck,
    bapModelInfoDuck,
    bapSelectedOptionsDuck,
} from '@/ducks/bap';

// containers
import BuildAndPriceBodyStyleSection from './BuildAndPriceBodyStyleContainer';
import BuildAndPriceDealerContainer from './BuildAndPriceDealerContainer';
import BuildAndPriceEmailOwnerContainer from './BuildAndPriceEmailOwnerContainer';
import BuildAndPriceFairMarketRangeContainer from './BuildAndPriceFairMarketRangeContainer';
import BuildAndPriceOptions from './BuildAndPriceOptions';
import BuildAndPriceSimilarInventoryCarouselContainer from './BuildAndPriceSimilarInventoryCarouselContainer';
import BuildAndPriceSummaryContainer from './BuildAndPriceSummaryContainer';
import BuildAndPriceTrimsSection from './BuildAndPriceTrimsSection';
import getBapTrimId from './utilities/getBapTrimId';

function BuildAndPriceOptionsContainer({
    device,
    trimsData,
}) {

    const dispatch = useDispatch();
    // select first trim by default on initial page load
    useEffect(() => {
        if (trimsData?.[0]?.trimId) {
            dispatch(bapModelInfoDuck.creators.setActiveTrim(getBapTrimId(trimsData[0])));
        }
        // trimsData should only load once on page load
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // trim value should have the format trimId-trimName
    const handleTrimChange = useCallback((event) => {
        dispatch(bapSelectedOptionsDuck.creators.reset());
        const { value } = event.target;
        dispatch(bapModelInfoDuck.creators.setActiveTrim(value));
        dispatch(bapActiveInteractionDuck.creators.setKeys({ lastTouched: null }));
    }, [dispatch]);

    return (
        <>
            <BuildAndPriceBodyStyleSection />
            <BuildAndPriceTrimsSection
                device={device}
                handleTrimChange={handleTrimChange}
            />
            <BuildAndPriceOptions />
            <BuildAndPriceSummaryContainer />
            <BuildAndPriceFairMarketRangeContainer />
            <BuildAndPriceSimilarInventoryCarouselContainer device={device} />
            <BuildAndPriceDealerContainer />
            <BuildAndPriceEmailOwnerContainer />
        </>
    );
}

export default React.memo(BuildAndPriceOptionsContainer);
